
export enum ChannelType {
  UserSelection = 0,
  FromAd = 1
}

export class UserChannelTerm {

  public ChannelTermId: string;

  public UserUpnId: string;

  public ChannelType: ChannelType;

  constructor(opt?: Partial<UserChannelTerm>) {
    Object.assign(this, opt);
  }
}
